export enum UserType
{
    INVESTIGATOR =1,
    ADMINRESEARCHCENTER,
    FONDOCYTUSER
}